import api from './api';

const service = {
  fetch: params => api.get('whitelist-domains', params),
  fetchById: id => api.get(`whitelist-domains/${id}`),
  whitelistDomain: params => api.post('whitelist-domains', params),
  unwhitelistDomain: id => api.delete(`whitelist-domains/${id}`),
  update: whitelistDomain =>
    api.put(`whitelist-domains/${whitelistDomain.id}`, whitelistDomain),
};

export default service;
